export const formatTransactionType = (type: string) => {
  const typeMap: { [key: string]: string } = {
    initial_payment: 'Membership',
    recurring_payment: 'Membership',
    renewal: 'Renewal',
    refund: 'Refund',
    cancellation: 'Cancellation',
    reactivation: 'Reactivation',
    token_purchase: 'Token Purchase',
    subscription_reload: 'Membership Tokens',
    tip: 'Tip',
  }

  return typeMap[type] || type
}
